import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import LabelForm from "./LabelsPage/LabelForm";

import type { LabelType } from "../types";

export default function AddLabelButton({
  labelType,
  size,
}: {
  labelType: LabelType;
  size: "sm" | "md" | "lg";
}) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  const Component = isDesktop ? Dialog : Drawer;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button
          leftIcon={<PlusCircle weight="fill" />}
          data-cy="create-label-button"
          size={size}
        >
          Create label
        </Button>
      </Trigger>
      <Content className="lg:w-[448px]">
        <LabelForm onBack={() => setIsOpen(false)} type={labelType} />
      </Content>
    </Component>
  );
}
